import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, useBreakpointValue } from '@chakra-ui/react';
import Header from './Header';
import Sidebar from './Sidebar';
import MobileNav from './MobileNav';

const Layout: React.FC = () => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  
  // 响应式配置
  const isMobile = useBreakpointValue({ base: true, lg: false });
  const contentPadding = useBreakpointValue({ 
    base: 4, 
    md: 6 
  });
  const contentMarginLeft = useBreakpointValue({ 
    base: 0, 
    lg: "256px" 
  });
  const contentPaddingTop = useBreakpointValue({ 
    base: "70px", 
    md: "75px" 
  });

  return (
    <Box minH="100vh" bg="gray.50" _dark={{ bg: 'gray.900' }}>
      <Header onMobileMenuToggle={() => setIsMobileNavOpen(!isMobileNavOpen)} />
      
      {/* 桌面端侧边栏 */}
      <Box display={{ base: 'none', lg: 'block' }}>
        <Sidebar />
      </Box>
      
      {/* 移动端导航 */}
      <MobileNav isOpen={isMobileNavOpen} onClose={() => setIsMobileNavOpen(false)} />
      
      {/* 主内容区域 */}
      <Box 
        p={contentPadding} 
        ml={contentMarginLeft} 
        pt={contentPaddingTop}
        transition="margin-left 0.3s ease"
        minH={`calc(100vh - ${contentPaddingTop})`}
        w={`calc(100vw - ${isMobile ? '0px' : '256px'})`}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout; 